export default "//static.tradera.net/touchweb/static/output/images/qr-code-google-play.28fdacc0.svg";